import axios from 'axios';

import { IMerchantDocument } from '@/shared/model/merchant-document.model';

const baseApiUrl = 'api/merchant-documents';

export default class MerchantDocumentService {
  public find(id: number): Promise<IMerchantDocument> {
    return new Promise<IMerchantDocument>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantDocument): Promise<IMerchantDocument> {
    return new Promise<IMerchantDocument>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantDocument): Promise<IMerchantDocument> {
    return new Promise<IMerchantDocument>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
